import React from 'react';
import Account from "./Account";
import {withRouter} from "./withRouter";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            loginError: null,
            isLoaded: false,
            userId: null
        };
    }

     componentDidMount() {
         fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
             method: "POST",
             headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
         }).then(res => res.json())
             .then(
                 (result) => {
                     this.setState({
                         isLoaded: true,
                         userId: result.id
                     });
                 },
                 (error) => {
                     this.setState({
                         isLoaded: false,
                         error,
                     });
                 }
             );
     }

    handleSubmit(e) {
        e.preventDefault();

        const body = {'email': e.target.email.value, 'password': e.target.password.value};

        fetch(process.env.REACT_APP_API_URL + '/my-account/login', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json'}
        }).then(res => res.json())
            .then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    userId: result.id
                });

                sessionStorage.setItem('token', result.password_sha + result.email + result.id)
            },
            (error) => {
                this.setState({
                    isLoaded: false,
                    error: error,
                    loginError: error
                });
            }
        );
    }

    render() {
        const { error, isLoaded, userId } = this.state;

        var content = null;

        if (error && !isLoaded) {
            content = (<Row className="vh-100 d-flex justify-content-center align-items-center">
                <Col md={8} lg={6} xs={12}>
                    <div className="border border-3 border-primary"></div>
                    <Card className="shadow">
                        <Card.Body>
                            <div className="mb-3 mt-md-4">
                                <center>
                                    <div className="row col-sm-6">
                                        <Button className="col-sm" variant="text-dark" type="submit">
                                            <a href={process.env.REACT_APP_BE_URL + "auth/github"}>
                                                <img width="65px" src="https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png"/>
                                            </a>
                                        </Button>
                                        <Button className="col-sm" variant="text-success" type="submit">
                                            <a href={process.env.REACT_APP_BE_URL + "auth/google"}>
                                                <img width="65px" src="https://assets.stickpng.com/images/580b57fcd9996e24bc43c51f.png"/>
                                            </a>
                                        </Button>
                                    </div>
                                </center>
                                <h2 className="fw-bold mb-2 text-uppercase ">ES</h2>
                                <p className=" mb-5">{this.state.loginError ? <div className="alert alert-danger">
                                    Invalid data. Please, try again
                                </div> : "Welcome back my young padawan"}</p>
                                <div className="mb-3">
                                    <Form onSubmit={this.handleSubmit.bind(this)}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                Email address
                                            </Form.Label>
                                            <Form.Control name="email" type="email" placeholder="Enter email" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control name="password"  type="password" placeholder="Password" />
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicCheckbox"
                                        >
                                            <p className="small">
                                                <a className="text-primary" href="/account/change-password">
                                                    Forgot password?
                                                </a>
                                            </p>
                                        </Form.Group>

                                        <div className="d-grid">
                                            <Button variant="primary" type="submit">
                                                Login
                                            </Button>
                                        </div>
                                    </Form>
                                    <div className="mt-3">
                                        <p className="mb-0  text-center">
                                            Don't have an account?{" "}
                                            <a href="/register" className="text-primary fw-bold">
                                                Sign Up
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>);

        } else if (isLoaded) {
            content = <Account userId={userId}/>;
        } else {
            content = <h1>Wait a second...</h1>;
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(Login);
